import React from "react";
import { Container, Typography, Box } from "@mui/material";

const AvisoPrivacidad_Es = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Aviso de Privacidad – Emoji Surveys
      </Typography>

      <Typography variant="body2" color="text.secondary" gutterBottom>
        Última actualización: Abril 2026
      </Typography>

      <Box mt={3}>
        <Typography paragraph>
          Emoji Surveys ("nosotros", "nuestro" o "la plataforma") es un servicio diseñado para capturar la satisfacción del cliente mediante encuestas interactivas con emojis. Nos comprometemos a proteger la privacidad de los usuarios y a garantizar la transparencia en el tratamiento de sus datos personales.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Información que Recopilamos
        </Typography>
        <Typography paragraph>
          Recopilamos información personal que usted proporciona de manera voluntaria al crear una cuenta. Esta información incluye su nombre y dirección de correo electrónico, los cuales son necesarios para la autenticación y administración de su cuenta. No recopilamos números telefónicos, datos de ubicación precisa (como GPS o seguimiento por IP), ni datos personales sensibles.
        </Typography>
        <Typography paragraph>
          En caso de suscribirse a un plan de pago, el procesamiento de los pagos se realiza de forma segura a través de proveedores externos como Stripe. Nosotros no almacenamos ni tenemos acceso directo a los datos completos de su método de pago.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Forma en que Recopilamos la Información
        </Typography>
        <Typography paragraph>
          La información es proporcionada directamente por usted mediante formularios de registro o a través de proveedores de autenticación como Google Sign-In. No utilizamos cookies con fines de seguimiento ni recolectamos información mediante APIs externas para analítica o marketing.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Uso de la Información
        </Typography>
        <Typography paragraph>
          La información recopilada se utiliza exclusivamente para la prestación y mejora del servicio. Esto incluye la creación y gestión de cuentas de usuario, el acceso a la plataforma, el procesamiento de pagos en caso de suscripciones y el envío de comunicaciones relacionadas con el servicio, como notificaciones de cuenta.
        </Typography>
        <Typography paragraph>
          No utilizamos sus datos personales con fines de marketing ni realizamos análisis de comportamiento o perfilamiento.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Compartición de Datos
        </Typography>
        <Typography paragraph>
          Únicamente compartimos su información con proveedores externos de confianza necesarios para el funcionamiento de la plataforma. Estos incluyen Stripe para el procesamiento de pagos y Google Firebase para servicios de hosting, autenticación y base de datos. Dichos proveedores manejan la información conforme a sus propias políticas de privacidad y estándares de seguridad.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Almacenamiento y Transferencias Internacionales
        </Typography>
        <Typography paragraph>
          Su información se almacena en infraestructura en la nube proporcionada por Google Firebase, la cual puede estar ubicada fuera de su país de residencia, incluyendo los Estados Unidos. Al utilizar la plataforma, usted acepta estas transferencias internacionales de datos.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Seguridad de la Información
        </Typography>
        <Typography paragraph>
          Implementamos medidas técnicas y organizativas adecuadas para proteger su información personal. Estas incluyen el uso de conexiones seguras HTTPS, mecanismos de autenticación y reglas de seguridad dentro de nuestra infraestructura en la nube.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Derechos del Usuario
        </Typography>
        <Typography paragraph>
          Usted tiene derecho a acceder, actualizar o corregir su información personal en cualquier momento a través de su cuenta. En caso de contar con una suscripción activa, podrá cancelarla en el momento que lo desee. Estos derechos se ejercen conforme a la legislación aplicable en materia de protección de datos.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Gestión de Sesiones
        </Typography>
        <Typography paragraph>
          Las sesiones de usuario son gestionadas de forma segura mediante Firebase Authentication para garantizar un acceso protegido a la plataforma.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Cambios al Aviso de Privacidad
        </Typography>
        <Typography paragraph>
          Nos reservamos el derecho de actualizar el presente Aviso de Privacidad en cualquier momento. Cualquier cambio relevante será notificado a los usuarios a través del correo electrónico registrado.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Contacto
        </Typography>
        <Typography paragraph>
          Si tiene dudas sobre este Aviso de Privacidad o el tratamiento de sus datos, puede contactarnos en: emojisurveypro@gmail.com
        </Typography>
      </Box>
    </Container>
  );
};

export default AvisoPrivacidad_Es;